import { FC } from "react";

import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
import CheckBox from "../../ui/input/CheckBox";
import { SubmitCartType } from "..";
import classes from "./index.module.scss";

type Props = {
  handleCheckboxChange: (
    identifier: keyof SubmitCartType,
    value: string | boolean
  ) => void;
  hasCutlery: boolean;
};

export const CutleryBanner: FC<Props> = ({
  hasCutlery,
  handleCheckboxChange,
}) => {
  const { language } = useLanguage();

  return (
    <div className={classes.container}>
      <p>{translate(translationsContent, "cutleryBannerContent1", language)}</p>
      <div className={classes.innerContainer}>
        <p className={classes.title}>
          {translate(translationsContent, "cutleryBannerContent2", language)}
        </p>
        <CheckBox<SubmitCartType, "wants_cutlery">
          identifier="wants_cutlery"
          onChange={handleCheckboxChange}
          checked={hasCutlery}
          label={`${translate(
            translationsContent,
            "cutleryBannerContent3",
            language
          )}`}
        />
      </div>
    </div>
  );
};
